import React, { Component } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { getFeatureName } from './utils';

class UserPermissionsList extends Component {
	render() {
		const { userPermissions, t } = this.props;
		const list = userPermissions && Array.isArray(userPermissions) ? _.sortBy(userPermissions, ['name']) : [];
		return (
			<>
				{(list ?? [])
					.map((permission) => t(getFeatureName(permission.featureId)))
					.filter(Boolean)
					.sort()
					.join(', ')}
			</>
		);
	}
}

UserPermissionsList.propTypes = {
	userId: PropTypes.string.isRequired,
};

const mapStateToProps = ({ session }) => ({
	loading: session.loading,
	defaultAccountId: session.defaultAccountId,
});

const mapDispatchToProps = () => ({});

export default compose(connect(mapStateToProps, mapDispatchToProps), withTranslation())(UserPermissionsList);
